import { Typography } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export const ZapierSteps = () => /*#__PURE__*/_jsx(Typography, {
  children: "2. Login to your Zapier account, create a zap with Anchor and paste the API key"
});